import React from 'react'
import { FaFacebook, FaGithub, FaInstagram, FaLinkedin, FaMailBulk } from 'react-icons/fa'


function Footer() {
    return (
        <div >
            <div className='footer'>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#001220"
                    fill-opacity="1" d="M0,192L48,170.7C96,149,192,107,288,96C384,85,480,107,576,133.3C672,160,
            768,192,864,186.7C960,181,1056,139,1152,106.7C1248,75,1344,53,1392,42.7L1440,32L1440,320L1392,
            320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,
            288,320C192,320,96,320,48,320L0,320Z"></path>
                </svg>
                <div className='row justify-content-center footer-content'>
                    <div className='col-md-6'>
                        <div>
                            <p>
                                Designed and Developed By
                            </p>
                            <hr />
                            <div className='d-flex justify-content-between px-2'>
                                <a  href='https://github.com/devesh-bhushan'><FaInstagram className='footer-icons' /></a>
                                <a  href="https://github.com/devesh-bhushan">  <FaGithub className='footer-icons' /></a>
                                <a  href="https://www.linkedin.com/in/devesh-bhushan-284b381aa/"><FaLinkedin className='footer-icons' /></a>
                                <a  href="mailto:deepubhushan123@gmail.com"><FaMailBulk className='footer-icons' /></a>
                                <a  href="https://www.facebook.com/devesh.bhushan.98"><FaFacebook className='footer-icons' /></a>
                            </div>
                            <hr /> <br />
                            <p>
                                Devesh Bhushan
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer
